import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    weekSelector: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 2),
      border: '1px solid #e0e0e0',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: 'white',
    },
    iconButton: {
      padding: '4px',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
    weekText: {
      margin: '0 4px',
      cursor: 'pointer',
      padding: '4px 8px',
      borderRadius: '4px',
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
    calendarDialog: {
      height: 'fit-content',
      width: '400px',
      overflow: 'hidden',
    },
    calendarDialogTitle: {
      marginTop: '8px',
      color: '#666',
    },
    calendarDialogContent: {
      padding: '0',
      overflow: 'hidden',
    },
    calendarPaper: {
      textAlign: 'left',
      overflow: 'hidden',
    },
  }),
);
